<template>
  <div v-if="!fetchingUserInfo">
    <div class="alert alert-limited" v-if="accessInfo.blurUnauthenticated">
      <h4 class="text-center">You must sign in to view this entire resource</h4>
      <p class="text-center">
        <a :href="signInReturn" class="btn btn-sm btn-primary">Sign in</a> or <a class="btn btn-primary btn-sm" :href="signUpReturn">Create an account</a>
      </p>
      <p>Creating an account also allows you to see alignment to state standards and Universal Design for Learning, adapted goals for varying levels of support, and related staircase goals by grade.</p>
    </div>

    <div class="alert alert-limited" v-if="accessInfo.blurTrial">
      <h4 class="text-center">This resource is available with a paid membership</h4>
      <p>Your trial membership allows you to view a sample of the resources Goalbook Toolkit has to offer.</p>
      <p class="text-center">
        <a class="btn btn-primary btn-sm" :href="toolkitUrls.subscribe">Membership Information</a>
      </p>
    </div>

    <div class="alert alert-danger" v-if="authInfo.isTrial && accessInfo.blurExpired">
      <h4 class="text-center">Join premium membership to view the entire page</h4>
      <p>Your trial has expired. To view the entire page you must join premium membership. <a :href="toolkitUrls.subscribe" aria-label="Learn more about membership">Learn more</a>.</p>
    </div>

    <div class="alert alert-danger" v-if="authInfo.isPremium && accessInfo.blurExpired">
      <h4 class="text-center">Your enterprise membership has lapsed</h4>
      <p>Your membership has ended. Please contact your administrator to renew your Toolkit enterprise membership.</p>
    </div>
  </div>
</template>

<script>
import { toolkitUrls, urlHelpers } from '@/links'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'LimitAccessAlert',
  props: {
    accessInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      toolkitUrls
    }
  },
  computed: {
    ...mapGetters('user', ['authInfo']),
    ...mapState('user', {
      fetchingUserInfo: state => state.fetching
    }),
    signInReturn() {
      return urlHelpers.signInReturn(this.$store.state.currentUrl)
    },
    signUpReturn() {
      return urlHelpers.signUpReturn('toolkit', this.$store.state.currentUrl)
    }
  },
}
</script>

<style scoped>
.alert.alert-limited {
  background-color: #f0f5e3;
  border: 1px solid #d1e1ad;
  color: #666;
}
</style>
